import { NavLink } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import lottie from "lottie-web";
import navbarLogoAnim from "../animations/navbar-logo.json";

const navLinks = [
  { to: "/", label: "Home", icon: "bi-house" },
  { to: "/courses", label: "Courses", icon: "bi-book" },
  { to: "/about", label: "About", icon: "bi-info-circle" },
  { to: "/contact", label: "Contact", icon: "bi-envelope" },
];

function Navbar() {
  const logoRef = useRef(null);
  const [sideOpen, setSideOpen] = useState(false);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: logoRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: navbarLogoAnim,
    });
    return () => anim.destroy();
  }, []);

  useEffect(() => {
    document.body.style.overflow = sideOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [sideOpen]);

  return (
    <>
      <nav className="navbar navbar-expand-lg sticky-top">
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <div ref={logoRef} className="navbar-logo-anim"></div>
          </NavLink>

          {/* Mobile hamburger */}
          <button
            className="navbar-toggler border-0 shadow-none d-lg-none"
            type="button"
            onClick={() => setSideOpen(true)}
          >
            <i className="bi bi-list" style={{ fontSize: '1.6rem' }}></i>
          </button>

          {/* Desktop nav */}
          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav ms-auto gap-1 align-items-center">
              {navLinks.map((link) => (
                <li className="nav-item" key={link.to}>
                  <NavLink
                    to={link.to}
                    end={link.to === "/"}
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active-link" : ""}`
                    }
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
              <li className="nav-item ms-lg-3">
                <NavLink to="/contact" className="btn btn-enroll">
                  <i className="bi bi-send me-2"></i>Enroll Now
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Side panel overlay */}
      <div className={`side-overlay ${sideOpen ? 'active' : ''}`} onClick={() => setSideOpen(false)} />

      {/* Side panel */}
      <div className={`side-panel ${sideOpen ? 'open' : ''}`}>
        <div className="side-panel-header">
          <span className="side-panel-title">Menu</span>
          <button className="side-panel-close" onClick={() => setSideOpen(false)}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        <ul className="side-panel-nav">
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `side-nav-link ${isActive ? "side-active" : ""}`
                }
                onClick={() => setSideOpen(false)}
              >
                <i className={`bi ${link.icon}`}></i>
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div className="side-panel-footer">
          <NavLink to="/contact" className="btn btn-enroll w-100" onClick={() => setSideOpen(false)}>
            <i className="bi bi-send me-2"></i>Enroll Now
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default Navbar;
